import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
import { cn } from "@/lib/utils";
export const CloudinaryIcon = t0 => {
  const $ = _c(9);
  let className;
  let svg;
  if ($[0] !== t0) {
    ({
      className,
      ...svg
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = svg;
  } else {
    className = $[1];
    svg = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-12", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fill="#ffffff" d="M24 14.86c0 2.173-1.376 3.974-3.59 4.7l-.1.031V17.99c1.378-.58 2.187-1.727 2.187-3.13a3.684 3.684 0 0 0-3.608-3.669h-.596l-.144-.569a6.5 6.5 0 0 0-6.272-4.97a6.392 6.392 0 0 0-5.81 3.664l-.184.376l-.417.044a4.431 4.431 0 0 0-3.305 2.088a4.431 4.431 0 0 0 1.458 6.095v1.69h-.01l-.149-.068a5.94 5.94 0 0 1-3.366-4.35a5.94 5.94 0 0 1 4.8-6.894a7.877 7.877 0 0 1 6.983-4.15a8.028 8.028 0 0 1 7.59 5.589A5.207 5.207 0 0 1 24 14.86M8.682 13.538h.565a.066.066 0 0 0 .046-.111l-2.209-2.211a.066.066 0 0 0-.093 0l-2.211 2.21a.066.066 0 0 0 .048.112h.556a.066.066 0 0 1 .066.065v5.058c0 .659.534 1.193 1.193 1.193h2.604a.066.066 0 0 0 .046-.112l-.33-.33a1.193 1.193 0 0 1-.348-.839v-4.97a.068.068 0 0 1 .067-.065m9.77 2.546h.566a.066.066 0 0 0 .046-.113l-2.21-2.209l-.002-.001a.064.064 0 0 0-.09.001l-2.211 2.209a.066.066 0 0 0 .046.113h.556a.066.066 0 0 1 .066.066v2.51c0 .66.534 1.193 1.193 1.193h2.606a.066.066 0 0 0 .046-.11l-.33-.33a1.193 1.193 0 0 1-.348-.84V16.15a.066.066 0 0 1 .066-.066m-4.885-1.274h.565a.066.066 0 0 0 .047-.111l-2.21-2.203h-.001a.066.066 0 0 0-.093 0l-2.208 2.207a.066.066 0 0 0 .045.111h.563a.068.068 0 0 1 .066.068v3.779c0 .659.534 1.193 1.192 1.193h2.599a.066.066 0 0 0 .047-.112l-.332-.33a1.193 1.193 0 0 1-.346-.839v-3.695c0-.037.03-.067.066-.068" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== svg || $[7] !== t1) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" role="img" fill="none" className={t1} viewBox="0 0 24 24" {...svg}>{t2}</svg>;
    $[6] = svg;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
CloudinaryIcon.displayName = "CloudinaryIcon";